module.exports = __webpack_public_path__ + "img/hair_back_female_wavy_medium_mask.e89bffec.png";